import { createSelector } from '@ngrx/store';
import { getMenuState, MenuState } from '../menu.reducer';
import { adapter } from './item-children.reducer';
import {asyncActionState} from '@emm/core/util/async-action-state';

const getState = createSelector(getMenuState, (state: MenuState) => state.itemChildren);

const entitySelectors = adapter.getSelectors(getState);
const asyncActionStateSelectors = asyncActionState.getSelectors(getState);

const getChildItems = createSelector(
    entitySelectors.selectEntities,
    (entities, props) => props && props.path && entities[props.path]
);

export const ItemChildrenSelectors = {
    entitySelectors,
    ...asyncActionStateSelectors,
    getChildItems
};
